export let IntegrationAppNames;
(function (IntegrationAppNames) {
  IntegrationAppNames["QUICKBOOKS_ONLINE"] = "QuickBooks Online";
})(IntegrationAppNames || (IntegrationAppNames = {}));